import Center from '@zenbusiness/zui/Center';
import { superstyled } from '@zenbusiness/zui/styles';

export const NumberedSectionNumber = superstyled({
  name: 'NumberedSection',
  slot: 'Number',
  tag: Center,
  styles: ({ theme }) => ({
    minWidth: '1.5rem',
    height: '1.5rem',
    background: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
    borderRadius: '50%',
    alignItems: 'center',
    fontWeight: theme.typography.fontWeightMedium,
    ...theme.typography.sm
  })
});
